import { shouldDisplayProviderAvailabilityTooltip } from '../../../../config/ab/selector';

export const mapStateToProps = state => {
    return {
        shouldDisplayProviderAvailabilityTooltip: shouldDisplayProviderAvailabilityTooltip(state),
    };
};
